// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__2ZYWJ","move-text":"loading_move-text__3XgS4"};